/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'townsquare-comments.comment-action-bar.delete-button': 'Löschen',
  'townsquare-comments.comment-action-bar.edit-button': 'Bearbeiten',
  'townsquare-comments.comment-action-bar.reply-button': 'Antworten',
  'townsquare-comments.comment.edited-date': 'Bearbeitet: {time}',
  'townsquare-comments.comments.comments-title':
    '{itemCount, plural, =0 {Kommentare} one {{itemCount,number} Kommentar} other {{itemCount,number} Kommentare}}',
};
